import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-underscore-dangle
import { prefixer } from 'stylis';
import { useTranslation } from '../i18n/LanguageProvider';

const caches = {
  rtl: createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin]
  }),
  ltr: createCache({
    key: 'muiltr',
    stylisPlugins: [prefixer]
  })
};

function RTL(props) {
  const { direction } = useTranslation();
  return (
    <CacheProvider value={caches[direction]}>{props.children}</CacheProvider>
  );
}

RTL.propTypes = {
  children: PropTypes.node
};

export default RTL;
